import React, { useState } from 'react';
import styled from 'styled-components';
import { Switch, Route } from 'react-router-dom';
import { useProfile } from '../../../Contexts/UserProfileContext';
import AgencyInformation from './AgencyInformation';
import { useAdvertisers } from '../../../Contexts/AdvertisersContext';
import { useAgency } from '../../../Contexts/AgencyContext';
import ViewAdvertisers from './ViewAdvertisers';
import usePost from '../../../Hooks/usePost';
import useRequest from '../../../Hooks/useRequest';

const AgencyContainer = styled.div`
    height: 100%;
    width: 100%;
    display: flex;
`;

const ConnectedAgency = () => {
    const { profile } = useProfile();
    const { agency } = useAgency();
    const {
        advertisers,
        setShouldFetchAdvertiserData,
        setShouldFetchOtherData,
        setCurrentAdvertiser,
        currentAdvertiser,
    } = useAdvertisers();
    const [modalIsOpen, setModalIsOpen] = useState(false);

    const { data, mutate: mutateGetAllAdvertisers } = useRequest('/getAllAdvertisersInAgency');

    const [newAdvertiser, setNewAdvertiser] = useState({
        isAgencyManager: true,
        agencyId: '',
        companyName: '',
        companyWebsite: '',
        firstName: '',
        lastName: '',
        title: '',
        primaryPhone: '',
        mobilePhone: '',
        streetAddress: '',
        country: '',
        city: '',
        province: '',
        zipCode: '',
    });

    const {
        isAgencyManager,
        companyName,
        companyWebsite,
        firstName,
        lastName,
        title,
        primaryPhone,
        mobilePhone,
        streetAddress,
        country,
        city,
        province,
        zipCode,
    } = { ...newAdvertiser };

    const [postData, setPostData] = useState({
        success: false,
        isLoading: false,
        error: false,
        message: [''],
    });

    const resetFields = () => {
        setNewAdvertiser({
            isAgencyManager: false,
            agencyId: 0,
            companyName: '',
            companyWebsite: '',
            firstName: '',
            lastName: '',
            title: '',
            primaryPhone: '',
            mobilePhone: '',
            streetAddress: '',
            country: '',
            city: '',
            province: '',
            zipCode: '',
        });
    };
    const { post } = usePost('/createAdvertiserInAgency');

    const createNewAdvertiser = async () => {
        try {
            setPostData({ ...postData, isLoading: true });
            const body = {
                isAgencyManager,
                agencyId: agency.agencyId,
                companyName,
                companyWebsite,
                firstName,
                lastName,
                title,
                primaryPhone,
                mobilePhone,
                streetAddress,
                country,
                city,
                province,
                zipCode,
            };

            const createNewAdvertiserResp = await post(body, 'POST');

            if (createNewAdvertiserResp.data) {
                await mutateGetAllAdvertisers();
                setShouldFetchAdvertiserData(true);
                setShouldFetchOtherData(true);
                resetFields();
                setPostData({
                    ...postData,
                    isLoading: false,
                    error: false,
                    success: true,
                    message: [''],
                });
                setModalIsOpen(false);
            } else {
                setPostData({
                    ...postData,
                    isLoading: false,
                    error: true,
                    success: false,
                    message: ['There was an error adding an advertiser.'],
                });
            }
        } catch (err) {
            setPostData({
                ...postData,
                isLoading: false,
                error: true,
                success: false,
                message: ['Something went wrong'],
            });
        }
    };

    return (
        <AgencyContainer>
            <Switch>
                <Route path="/portal/agency/agencyInformation">
                    <AgencyInformation agency={agency} profile={profile} />
                </Route>
                <Route path="/portal/agency/viewAdvertisers">
                    <ViewAdvertisers
                        currentAdvertiser={currentAdvertiser}
                        agencyAdvertiserData={data}
                        agency={agency}
                        profile={profile}
                        createNewAdvertiser={createNewAdvertiser}
                        newAdvertiser={newAdvertiser}
                        setNewAdvertiser={setNewAdvertiser}
                        postData={postData}
                        modalIsOpen={modalIsOpen}
                        setModalIsOpen={setModalIsOpen}
                        resetFields={resetFields}
                    />
                </Route>
            </Switch>
        </AgencyContainer>
    );
};

export default ConnectedAgency;
